import { useState, type ReactNode } from "react";

export default function PlanAccordion({
  title,
  description,
  defaultOpen = false,
  children,
}: {
  title: string;
  description: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="overflow-hidden rounded-[24px] border border-powlo-border bg-white">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        className="flex min-h-[84px] w-full items-center justify-between gap-5 border-0 bg-transparent px-6 py-7 text-left"
      >
        <span className="flex min-w-0 flex-col gap-1">
          <span className="font-powlo-display text-xl font-bold tracking-tight text-powlo-ink sm:text-2xl">{title}</span>
          <span className="text-sm leading-snug text-powlo-muted sm:text-[15px]">{description}</span>
        </span>
        <span className="flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-full border border-powlo-border px-4 text-sm font-bold text-powlo-ink">
          {open ? "Hide" : "Show"}
          <span className="text-lg text-powlo-indigo">{open ? "−" : "+"}</span>
        </span>
      </button>
      {open && <div className="border-t border-[#ECEAE3] p-6 sm:p-8">{children}</div>}
    </div>
  );
}
